const CONSENT_UPDATE_EVENT_NAME = "como_update";
export default CONSENT_UPDATE_EVENT_NAME;